import type { Product as SwProduct } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import { normalizeCustomField } from '@/utils/helper/normalizeCustomField'

/**
 * Maps a Shopware product variant to a normalized format with cleaned customFields
 * @param swVariant - The Shopware product variant from the API
 * @returns The mapped variant with normalized customFields
 */
export function hblMapProductVariant(swVariant: SwProduct): SwProduct {
    if (!swVariant) {
        return swVariant
    }

    // If variant has translated customFields, normalize the relevant fields
    if (swVariant.translated?.customFields) {
        return {
            ...swVariant,
            ...swVariant.translated,
            customFields: {
                ...swVariant.translated.customFields,
                special_price: normalizeCustomField(swVariant.translated.customFields?.special_price),
                special_base_price: normalizeCustomField(swVariant.translated.customFields?.special_base_price),
                savings_text: normalizeCustomField(swVariant.translated.customFields?.savings_text)
            }
        }
    }

    return swVariant
}
